import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { AddInventoryItem } from "./pages/AddItem";
import { ListItems } from "./pages/ListItems";
import { ListStatus } from "./pages/ListStatus/ListStatus";
import { InventoryHistory } from "./pages/InventoryHistory";
import { ReceiveIssueItems } from "./pages/ReceiveIssueItems/ReceiveIssueItems";
import { BincardItems } from "./pages/Bincard";
import { NodWereHouse } from "./nod-wereHouse";
import { DestuffingItems } from "./pages/Destuffing";

export const NodWereHouseRoute: IRoute = {
  title: "Warehouse",
  path: "/nod/ware-house",
  icon: HomeIcon,
  component: NodWereHouse,
  guard: true,
  subRoutes: [
    {
      icon: InfoIcon,
      component: AddInventoryItem,
      path: "/add-inventory",
      title: "Add Inventory Item",
    },
    {
      icon: InfoIcon,
      component: ListItems,
      path: "/list-inventory",
      title: "Inventory Items",
    },
    {
      icon: InfoIcon,
      component: ListStatus,
      path: "/status-inventory",
      title: "Inventory Status",
    },
    {
      icon: InfoIcon,
      component: InventoryHistory,
      path: "/inventory-history",
      title: "Inventory History",
    },
    {
      icon: InfoIcon,
      component: BincardItems,
      path: "/inventory-bincard",
      title: "Inventory Bincard",
    },
    {
      icon: InfoIcon,
      component: DestuffingItems,
      path: "/destuffing",
      title: "Destuffing",
    },
    // {
    //   icon: InfoIcon,
    //   component: ReceiveIssueItems,
    //   path: "/receive-issue",
    //   title: "Inventory Receive Issue Items",
    // },
  ],
};
